module.exports = __webpack_public_path__ + "static/zipcar-7a491e290ffd2c7ea2e95d24351f6a7a.png";